import React from 'react';
import { BundleDetailTemplate } from './BundleDetailTemplate';

export const BundleBenefits = () => <BundleDetailTemplate slug="benefits-compensation" />;
